/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable react/no-unescaped-entities */
import React, { FC, } from 'react';
import { Tooltip, IconButton, FormLabel } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { CustomInput, SelectDropDown, useAppSelector } from '../../globalUtils/globalExports';
import { CustomDropdownPropTypes } from '../../globalUtils/SelectDropDown/SelectDropDown';
import { CustomInputFieldPropTypes } from '../../globalUtils/CustomInput/CustomInput';
import './CreateRuleAlertLogic.css'
import { getReferenceDataReducer } from '../../rmsReduxStore/reduxExports';
// import { checkNumbersPaste, keyPressValidationForLength } from '../../globalUtils/globalHooks';

interface IAlarmList {
  severity: string,
  id: string,
  name: string
}

export interface customProps {
  alarmList?: IAlarmList[] | null;
  selectDropdownProps: CustomDropdownPropTypes | null;
  formLabel: string;
  isRequired: boolean;

  inputProps: CustomInputFieldPropTypes | null;
  createRuleFormData?: CreateRuleFormData | null
  handleFormDataChange?: Function
  isFirstHalfDisable?: Function
  isSecondHalfDisabled?: Function
}

const CreateRuleAlertLogic: FC<customProps> = (props) => {
  // const [expanded, setExpanded] = useState<boolean>(true);

  // const handleAccordionToggle = () => {
  // if (
  //   (Array.isArray(props?.selectDropdownProps?.selectValue) &&
  //     (!props?.selectDropdownProps?.selectValue.length || !props?.selectDropdownProps?.selectValue[0]?.name)) || 
  //   (!Array.isArray(props?.selectDropdownProps?.selectValue) &&
  //     (!props?.selectDropdownProps?.selectValue?.name))
  // ) {
  //   toast.error('Select an alarm first.', {
  //     position: 'bottom-left',
  //   });
  //   return;
  // }
  // if (!props?.selectDropdownProps?.isDisabled) {
  //   toast.error('Select an alarm first.', {
  //     position: 'bottom-left',
  //   });
  //   return;
  // }
  // setExpanded(!expanded);
  // };

  const { createRuleFormData, handleFormDataChange, isFirstHalfDisable, isSecondHalfDisabled } = props;
  const { alertLogicStopReasonCodeRefData } = useAppSelector(getReferenceDataReducer)

  console.log(createRuleFormData, 'createRuleFormData')

  // const isFirstHalfDisable = useCallback(() => {


  //     if(!createRuleFormData?.notificationTriggerIds && !createRuleFormData?.occurenceTime && !createRuleFormData?.numberOfOccurrence && !createRuleFormData?.alarmTypeId && !createRuleFormData?.alarmContinuesFor) {
  //       return false
  //     }
  //     if(createRuleFormData?.notificationTriggerIds || createRuleFormData?.occurenceTime || createRuleFormData?.numberOfOccurrence){
  //       return true
  //     }
  //     return false
  // },[createRuleFormData])

  // const isSecondHalfDisabled = useCallback(() => {

  //   if(!createRuleFormData?.notificationTriggerIds && !createRuleFormData?.occurenceTime && !createRuleFormData?.numberOfOccurrence && !createRuleFormData?.alarmTypeId && !createRuleFormData?.alarmContinuesFor) {
  //     return false
  //   }

  //   console.log((createRuleFormData?.alarmTypeId && createRuleFormData?.alarmTypeId?.length >0 ) || createRuleFormData?.alarmContinuesFor?.length >0,'tfvalue');

  //     if((createRuleFormData?.alarmTypeId && createRuleFormData?.alarmTypeId?.length >0 ) || createRuleFormData?.alarmContinuesFor?.length >0){
  //       return true
  //     }
  //     return false;
  // },[createRuleFormData])

  return (
    <>
      <div className='create__rule__alert__logic__wrapper'>
        <div className='create__rule__alert__logic__header__info__wrapper'>
          <div className='create_rule_alert_section_headings'>
            Alert Logic
          </div>
          <Tooltip
            title={
              <>
                Alert Logic can be configured either for Alarm or Stop Code-based Notifications:
                <br />
                Alarm:  Notify on new alarm (or) if an alarm persists for the duration set in ‘Alarm continues for’ field
                <br />
                Stop Reason Code: Notify on new charging session Stop Reason Code.
              </>
            }
            componentsProps={{
              tooltip: {
                sx: {
                  boxShadow: 'none',

                },
              },
            }}
          >
            <IconButton sx={{ padding: 0, marginLeft: 1 }}>
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
        <div className='alert__logic__row__content'>
          <div className='d-flex' style={{ gap: '15px', width: '100%' }}>
            <div className='custom__form__wrap-content-column alert__logic__alarm__dropdown'>
              <div className='flex-tooltip'>
                {props?.formLabel && (
                  <FormLabel className={'rms-form-label'} required={!isFirstHalfDisable?.() || props?.isRequired}>
                    {props?.formLabel}
                  </FormLabel>
                )}
              </div>

              {props?.selectDropdownProps !== null && (
                <SelectDropDown
                  selectValue={props?.selectDropdownProps?.selectValue}
                  selectOptions={props?.selectDropdownProps?.selectOptions}
                  handleSelectOptionChange={props?.selectDropdownProps?.handleSelectOptionChange}
                  selectDropDownId={props?.selectDropdownProps?.selectDropDownId}
                  selectDropDownName={props?.selectDropdownProps?.selectDropDownName}
                  isMultiSelect={props?.selectDropdownProps?.isMultiSelect}
                  isDisabled={props?.selectDropdownProps?.isDisabled || isFirstHalfDisable?.()}
                  handleClose={props?.selectDropdownProps?.handleClose}
                  renderToBody={props?.selectDropdownProps?.renderToBody}
                  secondaryLabel={props?.selectDropdownProps?.secondaryLabel}
                  secondaryLabelView={props?.selectDropdownProps?.secondaryLabelView}
                />
              )}

            </div>
            <div className='alert__logic__alarm__continues__for'>
              <div className='alert__logic__row__label'>
                Alarm Continues for
              </div>
              <div className='alert__logic__minute__input'>
                <CustomInput
                  inputPlaceHolder={''}
                  handleInputChange={props?.inputProps?.handleInputChange}
                  inputValue={props?.inputProps?.inputValue || ''}
                  inputFieldId={props?.inputProps?.inputFieldId || ''}
                  isRequired={props?.inputProps?.isRequired || false}
                  handleKeyPress={(e) => {
                    if (!/^\d$/.test(e.key) && e.key !== 'Backspace') {
                      e.preventDefault();
                    }
                  }}
                  isDisabled={props?.inputProps?.isDisabled || isFirstHalfDisable?.()}
                  errorMessage={props?.inputProps?.errorMessage}
                  autoFocus={props?.inputProps?.autoFocus}
                /> minutes
              </div>

            </div>
            {/* <Accordion
              expanded={expanded}
              onChange={handleAccordionToggle}
              sx={{ mt: 5, background:'#FAFAFA'}} 
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ padding: '4px 8px', margin: 0 }} 
              >
                <Typography variant="body2" sx={{ fontSize: '12px', margin: 0 }}>
                  Advanced option
                </Typography>
                <Tooltip title="If the Alarm continues for a specific time, then send notification">
                  <IconButton sx={{ padding: 0, marginLeft: 1 }}>
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </AccordionSummary>

              <AccordionDetails sx={{ padding: '4px 8px', margin: 0, maxHeight: '150px', overflow: 'auto' ,mb:'10px'}}>
                {/* Alarm continues for input and dropdowns */}
            {/* <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.75rem', whiteSpace: 'nowrap'}}
                  >
                    Alarm continues for
                  </Typography>

                  <div className={'custom__form__wrap-content-row ' + 'grid-2-custom'}>
                    <CustomInput
                      inputPlaceHolder={''}
                      handleInputChange={props?.inputProps?.handleInputChange}
                      inputValue={props?.inputProps?.inputValue || ''}
                      inputFieldId={props?.inputProps?.inputFieldId || ''}
                      isRequired={props?.inputProps?.isRequired || false}
                      handleKeyPress={(e) => {
                        // Allow only digits and the Backspace key
                        if (!/^\d$/.test(e.key) && e.key !== 'Backspace') {
                          e.preventDefault(); // Prevent non-numeric characters except Backspace
                        }
                      }}
                      isDisabled={props?.inputProps?.isDisabled}
                      errorMessage={props?.inputProps?.errorMessage}
                      autoFocus={props?.inputProps?.autoFocus}
                    />
                  </div>

                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.75rem', whiteSpace: 'nowrap'}}
                  >
                    minutes.
                  </Typography>
                </Box>
              </AccordionDetails> */}
            {/* </Accordion> */}
          </div>
        </div>

        <div className='d-flex justify-center align-center gap-4' style={{ backgroundColor: 'var(--sidebar-bg-color)', gap: '15px' }}>
          <hr className='custom-hr' />
          <div>OR</div>
          <hr className='custom-hr' />
        </div>

        <div className='alert__logic__row__content mt-0'>
          <div className='d-flex' style={{ gap: '15px', width: '100%' }}>

            <div className='custom__form__wrap-content-column alert__logic__alarm__dropdown d-flex-column gap-4'>
              <FormLabel className={'rms-form-label'} required={true}>
                Stop Reason Code
              </FormLabel>

              {(
                <SelectDropDown
                  selectValue={alertLogicStopReasonCodeRefData?.filter((item) => (createRuleFormData?.notificationTriggerIds?.includes(item?.id))) ?? []}
                  selectOptions={alertLogicStopReasonCodeRefData ?? []}
                  handleSelectOptionChange={(value) => {
                    handleFormDataChange?.(value, 'notificationTriggerIds')
                  }}
                  selectDropDownId={'stop-reason-code-filter-dropdown'}
                  // selectDropDownName={props?.selectDropdownProps?.selectDropDownName}
                  isMultiSelect={true}
                  isDisabled={isSecondHalfDisabled?.()}
                  // handleClose={/rops?.selectDropdownProps?.handleClose}
                  renderToBody={true}
                // secondaryLabel={props?.selectDropdownProps?.secondaryLabel}
                // secondaryLabelView={props?.selectDropdownProps?.secondaryLabelView}
                />
              )}

            </div>
            {/* <div className='alert__logic__alarm__continues__for d-flex-column gap-4 justify-space-around'>
            <div>
              {'Occurence logic'}
            </div>
            <div className='d-flex gap-4 align-center'>
                      <CustomInput
                      containerClassName={'create__rule__occurence__input'}
                      inputType={'number'}
                      inputValue={createRuleFormData?.numberOfOccurrence?? ''} 
                      inputFieldId={'occurence-count-alert-logic'} 
                      isRequired={false}
                      isDisabled={isSecondHalfDisabled?.()}
                      handleInputChange={(event) => {
                        handleFormDataChange?.(checkNumbersPaste(event?.target?.value), 'numberOfOccurrence');
                      }}
                      handleKeyPress = {(e) => keyPressValidationForLength(e, 2)}
                      
                      />
                      <div>times in</div>
                      <CustomInput 
                       containerClassName={'create__rule__occurence__input'}
                        inputType={'number'}
                      inputValue={createRuleFormData?.occurenceTime?? ''} 
                      inputFieldId={'occurence-time-alert-logic'} 
                      isRequired={false}
                      isDisabled={isSecondHalfDisabled?.()}
                      handleInputChange={(event) => {
                        handleFormDataChange?.(checkNumbersPaste(event?.target?.value), 'occurenceTime');
                      }}
                      handleKeyPress = {(e) => keyPressValidationForLength(e, 3)}
                      />
                      <span>minutes</span>
            </div>
              
          </div> */}


            {/* <div className='d-flex-column gap-4'>
                  <div>Stop Reason Code</div>
                  <SelectDropDown 
                    selectValue={createRuleFormData?.notificationTriggerIds}
                    selectOptions={[]}
                    handleSelectOptionChange={()=>{}}
                    selectDropDownId={'stop-reason-code-filter-dropdown'}
                    // selectDropDownName={props?.selectDropdownProps?.selectDropDownName}
                    isMultiSelect={true}
                    isDisabled={false}
                    // handleClose={/rops?.selectDropdownProps?.handleClose}
                    renderToBody={true}
                    // secondaryLabel={props?.selectDropdownProps?.secondaryLabel}
                    // secondaryLabelView={props?.selectDropdownProps?.secondaryLabelView}
              />

          </div>

          <div className='d-flex gap-4'>
                    <CustomInput
                     inputValue={createRuleFormData?.numberOfOccurrence?? ''} 
                     inputFieldId={'occurence-count-alert-logic'} 
                     isRequired={false}
                     handleInputChange={(event) => {
                       handleFormDataChange?.(event?.target?.value, 'numberOfOccurrence');
                     }}
                     
                     />

                     <CustomInput 
                     inputValue={createRuleFormData?.occurenceTime?? ''} 
                     inputFieldId={'occurence-time-alert-logic'} 
                     isRequired={false}
                     handleInputChange={(event) => {
                      handleFormDataChange?.(event?.target?.value, 'occurenceTime');
                    }}/>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateRuleAlertLogic;